/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { get_event_details } from '../store/reducers/eventDetailsReducer';

import GetSellerConfig from './GetSellerConfig';
import config from '../config';

const DiagnosticInfo = (parentPage, isDeposit) => {
    const sellerEnvironment = config.STR_ENVIRONMENT;

    const { 
        //seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        // sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        // sellerColorDark, sellerColorMedium, sellerColorLight, 
        // sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        // sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        // sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber, sellerShoppingTerm, 
        // sellerEventParts, sellerClothColors, sellerMinGuestCount, sellerServiceTypes, sellerPlaceSettings, sellerOtherEventOptionsChoices,
        // sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        // sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        // sellerPersonalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames, sellerChatOfflineMessage,

        // sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
        // sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, 
        sellerBoolShowSitePayments, 
        // sellerBoolShowSiteRating, sellerBoolShowCuisineType,
        // sellerBoolShowCookingMethods, sellerBoolShowHoliday, sellerBoolShowSiteChatOnline, sellerBoolShowQuantities
    } = GetSellerConfig();

    const { userInfo } = useSelector(state => state.auth);
    const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
    const paymentMode = ' customerDashboard, index, redirectPayment; eventDetails Strip.jsx'
        
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (userInfo?.id) dispatch(get_event_details(userInfo.id));
    }, [dispatch, userInfo?.id]);
    
    return (
        <div>
            {sellerEnvironment === 'Dev' && (
                <div className='w-[300px] bg-yellow-100 border border-yellow-700 text-yellow-700 rounded-md px-2 py-1
                    text-[12px] m-2 font-mono leading-tight text-right'>
                    <div>customer id: {userInfo?.id}</div> 
                    <div> eventDetails id: {eventDetails?._id}</div>
                    <span> eventDetails deposit: {String(eventDetails?.depositGiven)}</span>
                    <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments?.toString()}</div>
                    {paymentMode}
                </div>
            )}
        </div>
    );
};

export default DiagnosticInfo;


// <div className="text-[11px] bg-yellow-50 border border-yellow-300 rounded-md p-2 mb-3 font-mono leading-relaxed">
//     <div>eventDetails?._id: {eventDetails?._id}</div>
//     <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//     <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments?.toString()}</div>
//   </div>

// <div className="text-[11px] bg-yellow-50 border border-yellow-300 rounded-md p-2 mb-3 font-mono leading-relaxed">
//     <div>eventDetails?._id: {eventDetails?._id}</div>
//     <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//     <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments?.toString()}</div>
//   </div>


// <div className={` ${sellerEnvironment === 'Dev' ? '' : 'hidden'} text-[14px]`}>
//     <div className='font-semibold'>Payment.jsx page</div>
//     <div>eventDetails?._id</div>
//     <div>"_id": ObjectId("{eventDetails?._id}")</div>
//     <div>isDeposit: {isDeposit.toString()}</div>
//     <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//     <div>sellerBoolShowSitePayments: {sellerBoolShowSitePayments.toString()}</div>
// </div>

// {sellerEnvironment === 'Dev' && (
//                         <div className='text-[10px] opacity-50 font-mono leading-tight text-right'>
//                             <div>id: {eventDetails?._id}</div>
//                             <div>payments: {String(sellerBoolShowSitePayments)}</div>
//                         </div>
//                     )}


// {/* Dev debug panel */}
// {sellerEnvironment === 'Dev' && (
//     <div className='border border-yellow-700 text-yellow-700 bg-yellow-100 p-2 m-2 text-[14px]'>
//         <div>eventDetails?._id</div>
//         <div>&quot;_id&quot;: ObjectId(&quot;{eventDetails?._id}&quot;)</div>
//         <div>depositGiven: {eventDetails?.depositGiven?.toString()}</div>
//         <div>showPayments: {sellerBoolShowSitePayments.toString()}</div>
//     </div>
// )}



// {sellerEnvironment === 'Dev' && (
//     <div className='w-[300px] bg-yellow-100 border border-yellow-700 text-yellow-700 rounded-md px-2 py-1
//         text-[10px] font-mono leading-tight text-right'>
//         <span>id: {eventDetails?._id}</span>
//         <span>deposit: {String(eventDetails?.depositGiven)}</span>
//         <span>isDeposit: {String(isDeposit)}</span>
//     </div>
// )}
                                
                //                                 
                //                                 <span>isDeposit: {String(isDeposit)}</span>
                //                                 {sellerPaymentMode}